const DEFAULT_DELAY = 750

const defaultOptions = {
  isLoading: false,
  isBlocking: true
}

const Loading = {
  start (isBlocking = true) {
    this.state.isLoading = true
    this.state.isBlocking = isBlocking
  },

  end () {
    window.setTimeout(() => {
      this.state.isLoading = false
    }, DEFAULT_DELAY)
  },

  install (Vue, options) {
    if (this.installed) {
      return
    }

    this.installed = true

    Vue.prototype.$loading = this
    this.state = Object.assign(defaultOptions, options)
    this.state = Vue.observable(this.state)
  }
}

export default Loading
